/*
Slides

  --length <float> | inches
  --closingMechanism <string::combobox>
  --loadWeight <float> | pounds
  --overTravel <float> | inches | default: 0
  --mountType <string::enum> | ['Side Mount', 'Under Mount']
*/
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'
import { length, loadWeight } from '@/modules/standardItems/schemas/baseFormFields'
import { decimal } from 'vuelidate/lib/validators'

export default [
  ...hardwareFormFields,
  length({ classes: ['xs12', 'sm4'] }),
  {
    key: 'closingMechanism',
    value: 'closingMechanism',
    type: 'combobox',
    source: 'closingMechanisms/closingMechanismNames',
    fetch: 'closingMechanisms/get',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Closing Mechanism',
      class: ['input--dense']
    },
    saveOptions: {
      createAction: 'closingMechanisms/add',
      createMap: [{
        set: 'name'
      }],
      existingGetter: 'closingMechanisms/closingMechanismByName',
      // existingGetter: 'itemFinishes/itemFinishes',
      existingGetterParameter: 'name',
      newGetter: 'closingMechanisms/closingMechanism',
      saveNew: true,
      saveMap: [
        {
          get: 'name',
          set: 'closingMechanism'
        },
        {
          get: 'id',
          set: 'closingMechanismID'
        }
      ]
    },
    trackUpdates: ['closingMechanism', 'closingMechanismID']
  },
  loadWeight(),
  {
    key: 'overTravel',
    value: 'overTravel',
    type: 'float',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Over Travel',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  },
  {
    key: 'mountType',
    value: 'mountType',
    type: 'select',
    default: 'Soft',
    classes: ['xs12', 'sm4'],
    attributes: {
      label: 'Mount Type',
      class: ['input--dense']
    },
    values: ['Side Mount', 'Under Mount']
  }
]
